import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { NEVER, Observable, of } from 'rxjs';
import { catchError, filter, map } from 'rxjs/operators';
import { GlobalSettingsService } from '../../services/ui/global-settings.service';
import { SiteNote } from '../../models/site-notes/site-note.model';
import { SiteNotesService } from '../../services/sections/site-notes/site-notes.service';
import { ResolvedSiteNote } from './models/resolved-site-note.model';

@Injectable({
	providedIn: 'root'
})
export class SiteNoteItemResolver implements Resolve<Observable<ResolvedSiteNote>> {

	constructor(
		private router: Router,
		private siteNoteService: SiteNotesService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;
		const siteNoteId = +activatedRouteSnapshot.paramMap?.get('siteNoteId');
		if(!siteNoteId || siteNoteId <= 0) return of({data: null, hasError: true, errorMsg: "Invalid site note"})
		return this.siteNoteService.getSiteNote(activatedRouteSnapshot.paramMap.get('token'), siteNoteId)
			.pipe(
				map((siteNote: SiteNote) => ({data: siteNote, hasError: false, errorMsg: null})),
				catchError((error, caught) => {					
					let errorMsg = "Unable to get the site note details. Please try again!";
					if(error.status === 401) {
						errorMsg = "You cannot see this site note using the provided credentials"
					}
					return of({data: null, hasError: true, errorMsg: errorMsg})
				})
			);
	}
}
